// InputComponent.jsx
import React from "react";

const inputClassName =
  "block w-full rounded-xl border border-wa-border bg-wa-panel2/50 px-3.5 py-2.5 text-sm text-wa-text shadow-sm outline-none ring-1 ring-inset ring-wa-border/50 placeholder:text-wa-muted/70 [color-scheme:light] focus:border-wa-accent focus:ring-2 focus:ring-wa-accent/35 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-wa-panel/40 dark:[color-scheme:dark] sm:text-sm/6";

const ReInput = ({
  type,
  id,
  name,
  label,
  value,
  placeholder,
  onChange,
  disabled = false,
  required = false,
}) => {
  const commonInputProps = {
    id,
    name,
    onChange,
    value,
    placeholder,
    className: inputClassName,
  };

  let inputElement = null;

  switch (type) {
    case "text":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="text"
          {...commonInputProps}
        />
      );
      break;
    case "email":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="email"
          {...commonInputProps}
        />
      );
      break;
    case "textarea":
      inputElement = (
        <textarea disabled={disabled} rows={4} {...commonInputProps} />
      );
      break;
    case "checkbox":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="checkbox"
          {...commonInputProps}
        />
      );
      break;
    case "radio":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="radio"
          {...commonInputProps}
        />
      );
      break;
    case "date":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="date"
          {...commonInputProps}
        />
      );
      break;
    case "datetime":
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="datetime"
          {...commonInputProps}
        />
      );
      break;
    default:
      inputElement = (
        <input
          disabled={disabled}
          required={required}
          type="text"
          {...commonInputProps}
        />
      );
  }

  return (
    <div>
      <label
        htmlFor={id}
        className="block text-[11px] font-semibold uppercase tracking-wide text-wa-muted"
      >
        {label}
        {required ? <span className="ml-1 text-wa-accent">*</span> : null}
      </label>
      <div className="mt-1.5">{inputElement}</div>
    </div>
  );
};

export default ReInput;
